import React from 'react';
import { SurveyQuestion } from './SurveyQuestion';

export const SurveyLongAnswer = ({ option, hasVoted, onOptionUpdated }) => {
    const handleSelect = (event) => {
        onOptionUpdated(option.ballotOptionId, event.target.value)
    };

    return (
        <React.Fragment>
            <SurveyQuestion option={option} />
            <textarea type="text"
                id={option.ballotOptionId}
                disabled={hasVoted}
                onChange={handleSelect}
                value={option.textValue != null ? option.textValue : ''}
                rows="4"
                className="max-w-none"
                maxLength={option.surveyAnswerMaxCharacters !== null ? option.surveyAnswerMaxCharacters : undefined}
            />
        </React.Fragment>
    );
}